export default {
  props: {
    noLogin: Boolean,
    page: String,
    mypageRootPath: String,
    changeInfoUrl: String,
    clName: String,
    buildingName: String,
    buildingType: Number,
    isMgGroupMember: Boolean,
    isApp: Boolean,
    energyPage: String,
    mansionName: String,
    isVisibleLinkgates: Boolean,
    isVisibleMPoint: Boolean,
    current: Object,
    other_owners: Array,
    primal_oid: Number
  },

  computed: {
    changeInfoWindowWidth () {
      return this.isMgGroupMember ? 750 : 600
    },

    isReformMember () {
      return this.buildingType === 1
    },

    isKodateMember () {
      return this.buildingType !== 1 && this.buildingType !==2
    },

    isMansionMember () {
      return this.buildingType === 2
    },
  },

  methods: {
    clickChangeInfoUrl () {
      window.open(
        this.changeInfoUrl, '_blank',
        `-moz-width=${this.changeInfoWindowWidth},location=no,menubar=no,toolbar=no,scrollbars=yes,resizable=yes`)
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Common.js